




import {Component, Vue} from 'vue-property-decorator'
import DataGrid, {DataType} from '@/components/DataGrid.vue'
import {getStoredProcedure} from '@/data/repos/storedProcedure'
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import * as links from "@/data/sources/complianceLinks"

@Component({
  components: {
    DataGrid,
  },
})

export default class ComplianceLocationsWithNoElementsDrillDown extends Vue {
  public tableData: object[] = []
  public fields = [
    {name: 'SiteName', title: 'Site', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.site},
    {name: 'BuildingName', title: 'Building', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.building},
    {name: 'code', title: 'Code', dataType: 'Text', sort: 1},
  ]

  public getData() {
    const locationId = 10
    return getStoredProcedure(
      'AnalyticsCenter',
      'widget_ComplianceLocationsWithNoElementsDrillDown',
      [locationId, 1 /* user_id */],
      this.filter,
      0, 500)
  }

  private filter(data: any[]): any[] {
    return data.map(item => {
      return {
        SiteName: item.SiteName,
        SiteId: item.Siteid,
        BuildingName: item.BuildingName,
        BuildingId: item.Buildingid,
        code: item.code,
      }
    })
  }

}
